import { axiosInstance } from '../../../api';
const BASE_PATH = '/hiring_pipeline';

//invite Candidates API Call
export let inviteCandidates = async (emails, pipeline) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/add_candidates', {
            email: emails,
            hiring_pipeline: pipeline,
        })
        return value;
    } catch (error) {
        return error
    }
}

//get Candidate API Call
export let getCandidateInvitation = async (pipelineID, candidateID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_candidate_invitation', {
            pipeline_id: pipelineID,
            candidate_id: candidateID
        })
        return value;
    } catch (error) {
        return error
    }
}

//get Candidates By Step API Call
export let getCandidatesByStep = async (pipeline, pipelineStep, stepState) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_candidates_by_step', {
            hiring_pipeline: pipeline,
            current_pipeline_step: pipelineStep,
            candidate_step_state: stepState
        })
        return value;
    } catch (error) {
        return error
    }
}

//get Candidates By Step API Call
export let getCandidatesByPipeline = async (pipeline, stepState) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_candidates_by_pipeline', {
            hiring_pipeline: pipeline,
            candidate_pipeline_state: stepState,
        })
        return value;
    } catch (error) {
        return error
    }
}

//get selected type Candidate API Call
export let getCandidateDetails = async (candidateID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_candidate_details', {
            candidate_id: candidateID
        })
        return value;
    } catch (error) {
        return error
    }
}

//get selected type Candidate API Call
export let getPresignedUrlToViewCandidateCV = async (candidateID) => {

    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_presigned_url_to_view_candidate_cv', {
            candidate_id: candidateID
        })
        return value;
    } catch (error) {
        return error
    }
}

//get cover letter url
export let getPresignedUrlToViewCandidateCoverLetter = async (candidateID) => {

    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_presigned_url_to_view_candidate_cover_letter', {
            candidate_id: candidateID
        })
        return value;
    } catch (error) {
        return error
    }
}


//bypass Candidate manually API Call
export let bypassCandidateManually = async (candidateIDs, pipelineStep, reason) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/bypass_candidates_manually', {
            candidate_ids: candidateIDs,
            pipeline_step_to_be_moved: pipelineStep,
            reason: reason
        })
        return value;
    } catch (error) {
        return error
    }
}

//fail Candidate manually API Call
export let failCandidateManually = async (candidateIDs, pipelineStep, reason) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/fail_candidates_manually', {
            candidate_ids: candidateIDs,
            pipeline_step: pipelineStep,
            reason: reason
        })
        return value;
    } catch (error) {
        return error
    }
}

//move Candidate manually to selected Candidates API Call
export let moveToSelectedCandidatesManually = async (candidateID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/select_candidate', {
            candidate_id: candidateID
        })
        return value;
    } catch (error) {
        return error
    }
}


//invite Candidates API Call
export let addCandidate = async (data) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/add_candidates_manually', {
            candidate_id: data.candidate_id,
            candidate_image_type: data.candidate_image_type,
            is_invited_candidate: data.is_invited_candidate,
            is_cover_letter_uploaded: data.is_cover_letter_uploaded,
            candidate_first_name: data.candidate_first_name,
            candidate_last_name: data.candidate_last_name,
            mobile_country_code: data.mobile_country_code,
            mobile_number: data.mobile_number,
            referral_data: data.referral_data,
            manually_uploaded_status: data.manually_uploaded_status,
            expected_salary_amount: data.expected_salary_amount ? data.expected_salary_amount : null,
            expected_salary_currency: data.expected_salary_currency,
            available_date: data.available_date ? data.available_date : null,
            expected_salary_paid_by: data.expected_salary_paid_by
        })
        return value;
    } catch (error) {
        return error
    }
}

//mark as offer sent API Call
export let markAsOfferSentAPI = async (candidateIDs) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/mark_as_offer_sent_candidates', {
            candidate_ids: candidateIDs
        })
        return value;
    } catch (error) {
        return error
    }
}

//fail filtered candidate API Call
export let failFilteredCandidates = async (candidateIDs, reason) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/reject_filtered_candidates', {
            candidate_ids: candidateIDs,
            reject_reason: reason
        })
        return value;
    } catch (error) {
        return error
    }
}

//mark as offer rejected API Call
export let candidateRejectOffer = async (candidateIDs, reason) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/mark_as_candidates_declined_offer', {
            candidate_ids: candidateIDs,
            reject_reason: reason
        })
        return value;
    } catch (error) {
        return error
    }
}

//mark as candidate hired API Call
export let markAsCandidateHired = async (candidateIDs, reason) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/mark_as_candidates_hired', {
            candidate_ids: candidateIDs
        })
        return value;
    } catch (error) {
        return error
    }
}

//Get candidate email template wrapper Call
export let getCandidateEmailConfig = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_candidate_email_configs');
        return value;
    } catch (error) {
        return error
    }
}

export let getCandidateBulkEmailConfig = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_candidate_bulk_email_configs');
        return value;
    } catch (error) {
        return error
    }
}

//send candidate email

export let submitCandidateEmail = async (candidate_id, email_subject, email_body) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/send_candidate_email', {
            candidate_id: candidate_id,
            email_subject: email_subject,
            email_body: email_body
        });
        return value;
    } catch (error) {
        return error
    }
}

export let ExtendQuizTime = async (quiz_session_id, extending_quiz_time) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/extend_quiz_time', {
            quiz_session_id: quiz_session_id,
            extending_quiz_time: extending_quiz_time
        });
        return value;
    } catch (error) {
        return error
    }
}

export let extendAssessmentTime = async (assessment_session_id, extending_assessment_time) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/extend_external_assessment_time', {
            external_assessment_session_id: assessment_session_id,
            extending_assessment_time: extending_assessment_time
        });
        return value;
    } catch (error) {
        return error
    }
}

//Extend one-way interview time
export let extendOneWayInterviewTime = async (assessment_session_id, one_way_interview_time) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/extend_one_way_interview_time', {
            one_way_interview_session_id: assessment_session_id,
            one_way_interview_time: one_way_interview_time
        });
        return value;
    } catch (error) {
        return error
    }
}

//ReAssign the quiz API Call
export let ReAssignQuiz = async (quiz_session_id, extending_quiz_time) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/reassign_quiz', {
            quiz_session_id: quiz_session_id,
            extending_quiz_time: extending_quiz_time,
        });
        return value;
    } catch (error) {
        return error
    }
}

//ReAssign the assessment API Call
export let ReAssignAssessment = async (assessment_session_id, extending_assessment_time) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/reassign_external_assessment', {
            external_assessment_session_id: assessment_session_id,
            extending_assessment_time: extending_assessment_time,
        });
        return value;
    } catch (error) {
        return error
    }
}
//ReAssign the OneWayInterview API Call
export let ReAssignOneWayInterview = async (one_way_interview_session_id, extending_one_way_interview_time) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/reassign_one_way_interview', {
            one_way_interview_session_id: one_way_interview_session_id,
            one_way_interview_time: extending_one_way_interview_time,
        });
        return value;
    } catch (error) {
        return error
    }
}

//delete Candidate API Call
export let deleteCandidateProfile = async (candidateID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/delete_candidate_profile', {
            candidate_id: candidateID
        });
        return value;
    } catch (error) {
        return error
    }
}



